import { Injectable } from '@angular/core';
import { Observable, map, of, switchMap } from 'rxjs';
import { NavigationService } from '../../../core/service/navigation.service';
import { LicenseTypeKind } from '../../model/const/enum';
import { License } from '../../model/license';
import { LicenseService } from '../data/license.service';
import { UserAccountService } from '../user-account.service';

@Injectable({
  providedIn: 'root',
})
export abstract class LicenseGuard {
  constructor(
    private readonly _licenseService: LicenseService,
    private readonly _userAccountService: UserAccountService,
    private readonly _navigation: NavigationService
  ) {}

  canActivate(): Observable<boolean> {
    return this._cachedLicenses.pipe(
      switchMap(licenses =>
        this._checkCached(licenses)
          ? of(true) // <-- check cached licenses first
          : this._serverLicenses.pipe(map(licenses => this._checkCached(licenses, true)))
      )
    );
  }

  canActivateChild(): Observable<boolean> {
    return this.canActivate();
  }

  protected abstract get licenseTypeKind(): LicenseTypeKind; // LicenseTypeKind.ExtendedTechnicalManagement

  private get _cachedLicenses(): Observable<License[]> {
    return this._userAccountService.current.pipe(map(user => user.licenses));
  }

  private get _serverLicenses(): Observable<License[]> {
    return this._licenseService.getLicenses();
  }

  private _checkCached(licenses: License[], redirect: boolean = false): boolean {
    if (licenses?.some(license => license.licenseType === this.licenseTypeKind.valueOf())) {
      return true;
    }
    if (redirect) {
      this._navigation.navigatePageNotFound();
    }
    return false;
  }
}
